;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface Role {
  id: number;
  name: string;
}

interface Country {
  id: number;
  name: string;
  iso_code: string;
}

export interface Frequency {
  type: 'one_time' | 'daily' | 'weekly' | 'monthly' | 'custom';
  one_time_date?: string;
  daily_start_date?: string;
  daily_end_date?: string;
  weekly_days?: string[];
  monthly_day?: number;
  custom_interval?: number;
  custom_unit?: 'day' | 'week' | 'month';
  custom_end_type?: 'on' | 'after';
  custom_end_date?: string;
  custom_end_occurrences?: number;
  occurrences_count: number;
}

export interface Alert {
  id: number;
  alert_user_id: number;
  title: string;
  body: string;
  priority: 'critical' | 'highest' | 'medium';
  metadata?: {
    due_date?: string;
    invoice_id?: number;
    invoice_number?: number;
    due_date_display_type?: 'overdue';
    user_id?: number;
    organisation_id?: number;
    employee_name?: string;
    contract_end_date?: string;
    /** PaaS payroll-to-run alert period, e.g. `"10/2026"`. */
    date?: string;
    country_id?: number;
    country_name?: string;
    month_name?: string;
    period_month?: number;
    period_year?: number;
  };
  due_date_display?: string | null;
  cta_type: string;
  active: boolean;
  created_by: number;
  updated_by: number;
  created_at: string;
  updated_at: string;
  roles: Role[];
  countries: Country[];
  frequency: Frequency;
}
